import { Eyebrow, LineReveal, FadeUp } from "./Reveal";

export const PageHero = ({ eyebrow, titleLines, description }) => (
  <section className="relative overflow-hidden pb-20 pt-44 lg:pb-28">
    <div className="gold-radial pointer-events-none absolute inset-0" aria-hidden="true" />
    <div className="relative mx-auto w-full max-w-7xl px-6 lg:px-10">
      <FadeUp>
        <Eyebrow>{eyebrow}</Eyebrow>
      </FadeUp>
      <h1 className="mt-8 max-w-4xl font-serif text-5xl leading-[1.03] text-[#F5F5F5] sm:text-6xl lg:text-7xl">
        <LineReveal lines={titleLines} delay={0.1} />
      </h1>
      {description && (
        <FadeUp delay={0.4}>
          <p className="mt-8 max-w-2xl text-base font-light leading-relaxed text-[#A3A3A3] md:text-lg">
            {description}
          </p>
        </FadeUp>
      )}
    </div>
  </section>
);
